import { MapConfigurableOption } from "~/modules/catalog/category/composables/useElasticSearch/types";
import { useConfigStore } from "~/stores/extensionApi/config";

export const getConfigurableOptionsByProduct = (configurableOptions: MapConfigurableOption[]) => {
  const configStore = useConfigStore();
  const colorList = configStore.getColorList;

  let filtersMap = { color: [], size: [] };
  let size = [];
  let color = [];
  if (configurableOptions && configurableOptions.length > 0) {
    configurableOptions.forEach((configurableOption) => {
      const type = configurableOption.attribute_code;
      const filterVariants = configurableOption?.values?.map(({ uid, label, swatch_data, value_index, label_color }) => {
        const variant = { uid, label, swatch_data, value_index, type, label_color };
        
        if (type === 'color') {
          const prefix = label && label.length >= 2 ? label.substring(0, 2) : '';
          const code = label && label.length > 2 ? label.substring(2) : '';
          
          if (colorList && prefix && colorList[prefix]) {
            const colorName = colorList[prefix];
            variant.label_color = `${colorName} ${prefix}${code}`;
          } else if (colorList && colorList[value_index]) {
            variant.label_color = colorList[value_index];
          } else {
            variant.label_color = label;
          }
        }
        
        return variant;
      });

      if (type === "size") {
        size = size.concat(filterVariants || []);
      } else if (type === "color") {
        color = color.concat(filterVariants || []);
      }
    });
  }

  if (size.length > 0) {
    filtersMap["size"] = size;
  }

  if (color.length > 0) {
    filtersMap["color"] = color;
  }
  return filtersMap;
};
